import { render } from "./IconPlus.vue?vue&type=template&id=4e61edb6&ts=true"
import script from "./IconPlus.vue?vue&type=script&lang=ts"
export * from "./IconPlus.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__